<div class="app-report" 
[style.background-color]=" settingsData.form_bg_color+ ' !important'"
[style.color]=" settingsData.form_font_secondary_color + ' !important'">
  <div>
    <div>
      <!-- (click)="$event.stopPropagation()" -->
      <div class="title">
        <h4 class="fs-24">
          Report Abuse
        </h4>
        <div>
          <i class="fa fa-times-circle fs-25 pointer" aria-hidden="true" (click)="closePopup()"></i>
        </div>
      </div>
      <hr class="line" [ngStyle]="{'background-color': settingsData.form_bg_color ? settingsData.form_bg_color : null ,'color': settingsData.form_bg_color ? settingsData.form_bg_color : null ,
      'font-family': settingsData.font_family ? settingsData.font_family : null  }">
      <mat-radio-group (change)="onSelectCategory()" *ngIf="reportOptions.length > 0"
        [(ngModel)]="selectedReportCategory" #value="ngModel" class="custom-radio-button-vertical"
        [style.--radio-border-color]="settingsData?.bg_primary_color">
        <mat-radio-button [value]="report" class="pr-2 mt-10 mb-10 circle custom-radio" (change)="onRadioChange($event)"
          *ngFor="let report of reportOptions; let i = index"
          [ngStyle]="{
            '--radio-color': settingsData?.bg_primary_color || '#3f51b5',
            '--radio-label': settingsData?.form_font_secondary_color || '#3f51b5',
          }">
          <div>
            <span *ngIf="report.category.length <= 35" class="pointer">
              {{report.category }}
            </span>
            <span *ngIf="report.category.length > 35" matTooltipPosition="above"
              matTooltip="{{ report.category }}">
              {{ report.category | slice: 0:35}}
              {{report.category.length > 35 ? "..." : ""}}
            </span>
            <span class="fs-15 ml-5 report-info" (mouseover)="showReportInfo = true && helpHoverId = report.id"
              (mouseout)="showReportInfo = false && helpHoverId = null">
              <i class="fa fa-question-circle"></i>
            </span>
          </div>
          <div *ngIf="this.selectedReportCategoryId == report.id && report.sub_categories.length > 0">
            <mat-form-field class="w-100 colorChange"[ngStyle]="{'color': settingsData.font_tertiary_color ? settingsData.font_tertiary_color : null ,
            'font-family': settingsData.font_family ? settingsData.font_family : null  }"
            [style.--form-border-color]="settingsData?.font_tertiary_color">
              <mat-label [ngStyle]="{
                'color':settingsData?.font_tertiary_color}">Select One</mat-label>
              <mat-select  [ngClass]="{'custom-select-panel': isSettingsAvailable()}" [style.color]="settingsData?.font_tertiary_color + '!important'" [(ngModel)]="selectedReportSubCategory">
            
              <mat-option [ngClass]="{'custom-select-panel colorChange': isSettingsAvailable()}" [style.color]="settingsData?.font_tertiary_color + '!important'"
                          [value]="question?.id" 
                          class="hover-option"
                          [ngStyle]="{'--mat-option-selected-state-label-text-color': settingsData?.font_secondary_color,
                          '--mat-pseudo-checkbox-color': settingsData?.font_secondary_color}"
                          (click)="onSelectSubCategory()" *ngFor="let question of report.sub_categories">
                          
                {{ question?.category }}
              </mat-option>
            </mat-select>
            </mat-form-field>
          </div>
          <div class="report-info-class " *ngIf="showReportInfo && helpHoverId == report.id" [ngStyle]="{'background-color':settingsData?.toastr_bg_color,'color':settingsData?.toastr_font_color}">
            {{report.help}}
          </div>
        </mat-radio-button>
      </mat-radio-group>
    </div>
    <div *ngIf="reportValid" class="report-text-area">
      <mat-form-field class="double-line w-100" *ngIf="true" [style.--form-border-color]="settingsData?.font_tertiary_color"
      [ngStyle]="{
        
        'color':settingsData?.font_tertiary_color}">
        <mat-label [ngStyle]="{
          'color':settingsData?.font_tertiary_color}">Reason for reporting</mat-label>
        <textarea [(ngModel)]="reportReason" [style.color]="settingsData?.font_tertiary_color + '!important'" matInput required></textarea>
      </mat-form-field>
      <div class="cust-error " [ngStyle]="{'color': settingsData.font_tertiary_color ? settingsData.font_tertiary_color : null ,
      'font-family': settingsData.font_family ? settingsData.font_family : null  }" *ngIf="reportReason.length == 0">
        Please enter the reason for reporting*
      </div>
    </div>
    <div class="text-center mlr-20" *ngIf="reportOptions.length>0">
      <!-- <button mat-flat-button class="flat-secondary-button" (click)="closeForm()">Cancel</button> -->
      <button mat-flat-button (click)="reportValid && reportReason  ? onSubmit() : onSubmit()"
        class="flat-primary-button"
        [ngStyle]="{'background-color': settingsData.bg_primary_color ? settingsData.bg_primary_color : null ,'color': settingsData.font_primary_color ? settingsData.font_primary_color : null ,
        'font-family': settingsData.font_family ? settingsData.font_family : null  }">
        Report
      </button>
    </div>
    <div *ngIf="reportOptionsLength == 0" class="no-data" [ngStyle]="{'background-color': settingsData.bg_primary_color ? settingsData.bg_primary_color : null ,'color': settingsData.font_primary_color ? settingsData.font_primary_color : null ,
    'font-family': settingsData.font_family ? settingsData.font_family : null  }">
      No Data
    </div>
  </div>
</div>